import React, { ReactElement, useState } from 'react'
import style from './input-text.module.scss'

interface Props {
  value?: string;
  type?: string;
  placeholder: string;
  message?: string;
  state?: 'Default' | 'Success' | 'Error';
  leadingIcon?: ReactElement;
  trailingIcon?: ReactElement;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>, value: string) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement, Element>, value: string) => void;
}

const InputText = (props: Props) => {
  const [value, setValue] = useState(props.value || '');
  const state = props.state ? props.state : 'Default';

  return (
    <div className={[
      style.inputTextContainer,
      props.leadingIcon ? style.inputTextHasLeadingIcon : null,
      props.trailingIcon ? style.inputTextHasTrailingIcon : null,
    ].join(' ')}
    >
      <input
        type={props.type || 'text'}
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
          if (props.onChange) {
            props.onChange(e, e.target.value);
          }
        }}
        className={[
          style.inputText,
          style[`inputText${state}`],
          value != '' ? style.inputTextNotEmpty : null,
          props.leadingIcon ? style.inputTextHasLeadingIcon : null,
          props.trailingIcon ? style.inputTextHasTrailingIcon : null,
        ].join(' ')}
        onBlur={(e) => {
          if (props.onBlur) {
            props.onBlur(e, value)
          }
        }}
      />
      {props.leadingIcon ?
        <div className={style.inputTextLeadingIconContainer}>
          {props.leadingIcon}
        </div>
        : null}

      {props.trailingIcon ?
        <div className={style.inputTextTrailingIconContainer}>
          {props.trailingIcon}
        </div>
        : null}

      <div className={style.inputTextPlaceholder}>{props.placeholder}</div>
      <div className={style.inputTextMessages}>{props.message}</div>
    </div>
  )
}

export default InputText
